/**
 * The high score (spec 08 §2: TOP). The C64 kept one, with no name, until it was switched off; here
 * it is also kept in the browser between visits. Scores are in the sim's units (the panels show ten
 * times the number).
 */

/** The C64's default high score, 20,000 on screen (research R§10). */
const DEFAULT_HI = 2000;
const KEY = 'bubble-bobble.hiscore';

export class HiScore {
  private best = DEFAULT_HI;
  private saved = DEFAULT_HI;

  constructor() {
    try {
      const v = Number.parseInt(localStorage.getItem(KEY) ?? '', 10);
      if (Number.isFinite(v) && v > DEFAULT_HI && v < 1e8) this.best = this.saved = v;
    } catch {
      // storage blocked: the default, for this visit
    }
  }

  get value(): number {
    return this.best;
  }

  offer(score: number): void {
    if (score > this.best) this.best = score;
  }

  /** Keep it (at the natural pauses: a level's end, game over, the title). */
  save(): void {
    if (this.best === this.saved) return;
    try {
      localStorage.setItem(KEY, String(this.best));
      this.saved = this.best;
    } catch {
      // storage full or blocked
    }
  }
}
